export class AddressModel {
  countryDictId: number;
  provinceDictId: number;
  cityDictId: number;
  street: string;
  houseNumber: string;
  flatNumber: string;
  postalCode: string;
  userId: number;
  id: number;
  version: number;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/personal-data/address-model.ts